<div class="role4-120000-form-container">
  <p-toast></p-toast>
  <app-sheet-loader [visible]="isLoading" />

  <p-card [header]="formTitle" [subheader]="isDev ? '[120000] Disclosure - Directors Report' : ''" *ngIf="!isLoading && schema && directorsReportForm" class="form-card">

    <div class="bg-gray-200 text-black-700 text-sm font-medium px-2 py-1">Disclosure on directors report</div>
    <div class="bg-gray-200 text-black-700 text-sm font-medium px-3 py-1">Director's Report</div>
    
    <form [formGroup]="directorsReportForm">
      <!-- Dynamic Fields -->
      <ng-container *ngFor="let control of schema.controls">
        <div class="form-field" *ngIf="shouldShowField(control)">
          <label class="field-label" [class.required]="isFieldRequired(control)">
            {{ control.label }}<app-required-marker [when]="isFieldRequired(control)" />
            <!-- <span class="warning-mark" *ngIf="hasWarnings(control.qname)">*</span> -->
          </label>

          <!-- Text Input -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'text'">
            <input
              type="text"
              pInputText
              [formControlName]="control.qname"
              [placeholder]="control | placeholder"
              [pKeyFilter]="shouldBeNumericOnly(control.qname) ? 'num' : null"
              [maxlength]="getMaxLength(control.qname)"
              class="w-full"
            />

            <!-- Error Messages (Multiple) -->
            <div *ngIf="hasError(control.qname)" class="error-messages">
              <div *ngFor="let errorMsg of getAllErrorMessages(control.qname)" class="error-message" [innerHTML]="errorMsg"></div>
            </div>

            <!-- Warning Messages -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

          <!-- Rich-text (WYSIWYG) field — same preview + pop-out editor as role
               750000 (AS-897). type: TextBlock, required. Value stays a plain
               HTML string; required parity holds because the field normalizes
               empty content to '', which Validators.required treats as empty. -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'richtext'">
            <app-rich-text-field
              [formControlName]="control.qname"
              [title]="control.label"
              [placeholder]="control | placeholder: 'Click to add content…'"
              [invalid]="!!(getControl(control.qname)?.invalid && getControl(control.qname)?.touched)"
            ></app-rich-text-field>

            <!-- Error Messages (Multiple) -->
            <div *ngIf="hasError(control.qname)" class="error-messages">
              <div *ngFor="let errorMsg of getAllErrorMessages(control.qname)" class="error-message" [innerHTML]="errorMsg"></div>
            </div>

            <!-- Warning Messages -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

          <!-- Select/Dropdown -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'select'">
            <p-select
              [formControlName]="control.qname"
              [options]="getDropdownOptions(control.ui.enumSource)"
              optionLabel="label"
              optionValue="value"
              [placeholder]="control | placeholder: 'Please select'"
              class="w-full"
              [filter]="true"
              filterPlaceholder="Search..."
              [showClear]="true"
            ></p-select>

            <!-- Error Messages (Multiple) -->
            <div *ngIf="hasError(control.qname)" class="error-messages">
              <div *ngFor="let errorMsg of getAllErrorMessages(control.qname)" class="error-message" [innerHTML]="errorMsg"></div>
            </div>

            <!-- Warning Messages -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>

          <!-- Date Picker -->
          <div class="field-input-wrapper" *ngIf="control.ui.control === 'date'">
            <p-datepicker
              [inputId]="control.qname"
              [formControlName]="control.qname"
              dateFormat="yy-mm-dd"
              [showIcon]="true"
              iconDisplay="input"
              [placeholder]="control | fixedPlaceholder: 'Select a date'"
              class="w-full"
              [class.p-invalid]="hasError(control.qname)"
              (onInput)="onInputChange($event)"
            ></p-datepicker>

            <!-- Error Messages (Multiple) -->
            <div *ngIf="hasError(control.qname)" class="error-messages">
              <div *ngFor="let errorMsg of getAllErrorMessages(control.qname)" class="error-message" [innerHTML]="errorMsg"></div>
            </div>

            <!-- Warning Messages -->
            <app-warning-message [warnings]="getAllWarnings(control.qname)"></app-warning-message>
          </div>
        </div>
      </ng-container>
    </form>

    <!-- Form Status -->
    <!-- <div *ngIf="!isLoading && schema && directorsReportForm" class="form-status mt-4">
      <p>
        <strong>Form Status:</strong>
        <span [class]="directorsReportForm.valid ? 'text-green-600' : 'text-red-600'">
          {{ directorsReportForm.valid ? 'Valid ✓' : 'Invalid - Please fill required fields' }}
        </span>
      </p>
      <p>
        <strong>Total Fields:</strong> {{ schema.controls.length || 0 }}
      </p>
      <p>
        <strong>Auto-save:</strong>
        <span class="text-green-600">Enabled (500ms debounce)</span>
      </p>
    </div> -->
    <submit-for-validation
      [form]="directorsReportForm"
      [sheetKey]="'directorsReport'"
      [formTitle]="formTitle"
      [visibleFormData]="getVisibleFormData()"
      (cancelConfirmed)="onCancelConfirmed()"
    ></submit-for-validation>

  </p-card>
</div>
